import { render, staticRenderFns } from "./ConversationHeader.vue?vue&type=template&id=207a924b"
import script from "./ConversationHeader.vue?vue&type=script&lang=js"
export * from "./ConversationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports